import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { App } from './app';
import './hooks/useTranslation/i18n'; /// i18nライブラリ(多言語対応)の初期化

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
